import { execOnLoad } from '@general/helpers';
import { openModal } from '@components/modals';
import './size-chart-drawer.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initSizeChartDrawer = async (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const sizeChartDrawer = document.querySelector('#SizeChartDrawer');
  const sizeChartTrigger = document.querySelector(
    '#product-page__size-chart-trigger',
  );

  if (sizeChartDrawer && sizeChartTrigger) {
    sizeChartTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      openModal(sizeChartDrawer);
    });
  }

  if (window.KiwiSizing) {
    const sizeChart = document.querySelector('.product-page__size-chart');
    if (sizeChart) {
      sizeChart.style.display = 'block';
    }
  }
};

execOnLoad(window.dAgency.initSizeChartDrawer, '.size_chart_drawer__section');
